import { useState, useEffect } from "react";
import InvitationConfig from "@serie3/common/Modules/Invitations/Resources/Endpoints";
import crudApi from "@serie3/common/api/crudApi";
import { Row, Col, Card, CardBody, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faX } from "@fortawesome/free-solid-svg-icons";
import listHandler from "@serie3/common/Domain/listHandler";

const Invitations = () => {
  const [invitations, setInvitations] = useState([]);

  useEffect(() => {
    const getInvitations = async () => {
      await crudApi.getAll(
        InvitationConfig.endpoints.listOwnInvitations,
        setInvitations,
        InvitationConfig.datafield
      );
    };
    getInvitations();
  }, []);

  const accept = async (invitation, index) => {
    const acceptUrl = InvitationConfig.endpoints.accept + invitation.id;
    listHandler.deleteFromList(
      index,
      crudApi.edit(acceptUrl, []),
      setInvitations,
      invitations
    );
  };

  const decline = async (invitation, index) => {
    const declineUrl = InvitationConfig.endpoints.decline + invitation.id;
    listHandler.deleteFromList(
      index,
      crudApi.del(declineUrl, []),
      setInvitations,
      invitations
    );
  };

  return (
    <>
      {invitations.length > 0 ? (
        <Row>
          <Col>
            <Card>
              <CardBody>
                <Table>
                  <thead>
                    <tr>
                      <td>Groupname</td>
                      <td>Role</td>
                      <td>Promocode</td>
                      <td></td>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    {invitations.map((invitation, index) => (
                      <tr key={invitation.id ?? index}>
                        <td>{invitation.groupname}</td>
                        <td>
                          {Array.isArray(invitation.caps)
                            ? invitation.caps.join(", ")
                            : invitation.caps}
                        </td>
                        <td>
                          {invitation.promo_code}
                        </td>
                        <td>
                          <span
                            className="d-inline-flex align-items-center justify-content-center rounded-circle bg-success text-white"
                            style={{ width: "20px", height: "20px" }}
                            onClick={() => {
                              accept(invitation, index);
                            }}
                          >
                            <FontAwesomeIcon icon={faCheck} />
                          </span>
                        </td>
                        <td>
                          <span
                            className="d-inline-flex align-items-center justify-content-center rounded-circle bg-danger text-white"
                            style={{ width: "20px", height: "20px" }}
                          >
                            <FontAwesomeIcon
                              icon={faX}
                              onClick={() => {
                                decline(invitation, index);
                              }}
                            />
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      ) : (
        <Row>
          <Col>No Invitations</Col>
        </Row>
      )}
    </>
  );
};
export default Invitations;
